import React, { useState } from 'react';
import tapIcon from '../../services/TapIcon';
import { connect, useSelector } from 'react-redux';
import Loader from "../../components/ui/Loader/Loader";
import ApplicationLayout from '../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import HttpAPICall from "../../services/HttpAPICall";
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import TapIcon from '../../services/TapIcon';
import CreatableSelect from "react-select/creatable";


const DeviceData = ({ history }) => {

    const [imei, setImei] = useState('');
    const [loading, setLoading] = useState(false);
    const [deviceData, setDeviceData] = useState(null);
        const [selectedImei, setSelectedImei] = useState(null);
    
    const access_token = useSelector(state => state.auth.access_token);

    const [imeiOptions, setImeiOptions] = useState([
              { value: '352592572010858', label: '352592572010858 - Honda City' },
              { value: '353691841172736', label: '353691841172736 - Not Mapped' },
              { value: '353691841180044', label: '353691841180044 - Ofc Genset' },
          ]);
    const selectTapHandle = (selectedOption, fieldName) => {
        if (fieldName === 'imei') {
            setSelectedImei(selectedOption);
            if (selectedOption) {
                setImei(selectedOption.value);
            } else {
                setImei('');
            }
        }
    };
     const handleImeiCreate = (inputText) => {
        const newOption = {
            value: inputText,
            label: `${inputText} `
        };
        
        setImeiOptions(prev => [...prev, newOption]);
        
        setSelectedImei(newOption);
        setImei(inputText);
        
    };
    const fetchDeviceData = (imei) => {
        if (!imei.trim()) {
            toast.error('Please enter IMEI number', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        setLoading(true);
        setDeviceData(null);

        HttpAPICall.withAthorization('GET', `http://tappetbox.mysolutions.in/api/DeviceData/latest/${imei}`, access_token, {}, {}, (resp) => {
            setDeviceData(resp.data);
            toast.success('Device data fetched successfully', { position: toast.POSITION.TOP_RIGHT });
        }, (error) => {
            toast.error('Failed to fetch device data', { position: toast.POSITION.TOP_RIGHT });
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        fetchDeviceData(imei);
    };

    const openGoogleMaps = () => {
        if (!deviceData || !deviceData.latitude || !deviceData.longitude) {
            toast.error('Location data not available', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        const { latitude, longitude } = deviceData;
        const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
        window.open(mapsUrl, '_blank');
    };

    const formatValue = (key, value) => {
        if (value === null || value === undefined) return 'N/A';

        if (typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        }

        if (typeof value === 'number') {
            switch (key) {
                case 'speed':
                    return `${value} km/h`;
                case 'direction':
                    return `${value}°`;
                case 'altitude':
                    return `${value} m`;
                case 'externalVoltage':
                case 'batteryVoltage':
                    return `${value} V`;
                default:
                    return value.toString();
            }
        }

        if ((key.toLowerCase().includes('time') || key.toLowerCase().includes('date')) && !isNaN(Date.parse(value))) {
            return new Date(value).toLocaleString();
        }

        return value.toString();
    };

    const renderDeviceData = () => {
        if (!deviceData) return null;

        return (
            <div className="row mt-4">
                <div className="col-sm-9">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h5 className="card-title mb-0">Response</h5>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={openGoogleMaps}
                                disabled={!deviceData.latitude || !deviceData.longitude}
                            >
                                <TapIcon.FontAwesomeIcon icon={TapIcon.faMap} className="me-2" />
                                Map View
                            </button>
                        </div>
                        <table className="table table-hover table-borderless">
                            <tbody>
                                {Object.entries(deviceData).map(([key, value]) => (
                                    <tr key={key}>
                                        <td className="details-label" style={{ "width": "34%" }}>{key}</td>
                                        <td className="details-name" style={{ "width": "66%" }}>{formatValue(key, value)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Device Data</title></Helmet>
            <div className="page_title row m0">
                <div className="col-12">
                    <h3>Latest Device Data</h3>
                </div>
            </div>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        <div className="bg-white p-3">
                            <form onSubmit={handleSubmit}>
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label htmlFor="imei" className="form-label require">IMEI Number</label>
                                    </div>
                                    <div className="col-sm-4">
                                       
                                        <CreatableSelect
                                            required={true}
                                            value={selectedImei}
                                            options={imeiOptions}
                                            onChange={(selectedOption) => selectTapHandle(selectedOption, 'imei')}
                                            onCreateOption={handleImeiCreate}
                                            isClearable={true}
                                            isMulti={false} 
                                            placeholder="Please Select IMEI Number"
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    borderColor: '#dee2e6',
                                                    minHeight: '38px'
                                                })
                                            }}
                                        />
                                    </div>
                                    <div className="col-sm-2 ms-4">
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="btn btn-primary"
                                        >Go
                                            {loading && (
                                                <>
                                                    <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>

                            {loading && <Loader />}

                            {renderDeviceData()}
                        </div>
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};

export default DeviceData;